import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { format } from 'date-fns';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

const MSDPreview = (props) => {

    const getSubmittedDate = () => {
        const match = props.msdDetails?.match(/File Request Date:(.*)/);
        return match ? format(match[1].trim().substring(0, 10), 'yyyy-MM-dd') : '';
    }
    return (
        <Dialog open={props.preview}
            onClose={props.onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}
            overlayStyle={{ backgroundColor: 'transparent' }}
            scroll='paper'
            fullWidth
            maxWidth='md'
        >
            <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundImage: 'none' }}>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                    MSD Preview
                    <span style={{ fontSize: 14 }}>
                        {`(${getSubmittedDate()})`}
                    </span>
                </div>
                <IconButton
                    onClick={props.onClose}
                    style={{ color: 'white' }}
                    aria-label="close"
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <pre>
                    {props.msdDetails}
                </pre>
            </DialogContent>
        </Dialog>
    )
}

export default MSDPreview